import { data } from "jquery";
import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

class DeductDataService extends DataService {
    constructor() {
        super("deduct")
    }

    deduct(items, paymentMethod, nik) {
        let product_request = [];
        items.map((item) => {
            let requestItem = {
                product_id: item.product_id,
                stock_deduction: item.product_stock,
                discounted_price: item.discounted_price,
                // send product_type for e-money products, null for others
                product_type: item.product_type !== undefined ? item.product_type : null,
            };
            
            if (item.product_price !== undefined) {
                requestItem.product_price = item.product_price;
            }
            if (item.original_price !== undefined) {
                requestItem.original_price = item.original_price;
            }
            
            return product_request.push(requestItem);
        })
        const body = {
            product_request: product_request,
            status: paymentMethod,
            nik: nik,
        }

        return super.add(body);
    }

    get(clause) {
        return authFetch(process.env.REACT_APP_API_URL + '/transaction?order_id=' + clause, 'GET', null)
            .then((data) => {
                return {
                    checkout: data.data != null && data.data.errorMessage === undefined ? data.data : undefined,
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }

    getList(dateRange, currentPage, perPage) {
        let daterangeQuery = '';
        if (dateRange[0] !== undefined) {
            daterangeQuery = '&from=' + dateRange[0];
        }

        if (dateRange[1] !== undefined) {
            daterangeQuery += '&to=' + dateRange[1];
        }

        return authFetch(process.env.REACT_APP_API_URL + '/order?page=' + currentPage + '&per_page=' + perPage + daterangeQuery,
                        'GET', null)
                    .then((data) => {
                        return {
                            checkouts: data.data.order_data !== null && data.data.errorMessage === undefined ? data.data.order_data : [],
                            totalPages: data.data.total_order_data < perPage ? 1 : Math.ceil(data.data.total_order_data / perPage),
                            errorMessage: data.data?.errorMessage,
                            needRelogin: data.data?.needRelogin,
                        }
                    })
    }

    disable(transactionId) {
        return authFetch(process.env.REACT_APP_API_URL + '/transaction/del?transaction_id=' + transactionId, 'GET', null);
    }

    deleteCashbon(transactionId) {
        return authFetch(process.env.REACT_APP_API_URL + '/transaction/change?transaction_id=' + transactionId, 'GET', null);
    }
}

export default DeductDataService;
